import React from "react";
import { useEffect } from "react";
import { action_fetch_order_list_return } from "../../../../../../../store/actions/pages/customer";
import { useStore } from "react-redux";
import { useParams } from "react-router-dom";
import { useQuery } from "../../../../../../hooks/common";
import { useSelector } from "react-redux";
import { OrderReturnList } from "../fragments/order-list";
import OrderListEmpty from '../fragments/list-empty/index';
import { useCallback } from "react";
import { useDispatch } from "react-redux";

const OrderListReturn = props =>{
	const store = useStore();
	const params = useParams();
	const query = useQuery();
	const pageCustomer = useSelector(state=>state.pageCustomer);    
	const { orderListReturn } = pageCustomer;
	const dispatch = useDispatch();

	useEffect(async () => {
		if (window.__INITIAL_STATE__) {
            // Allow the passed state to be garbage-collected
            delete window.__INITIAL_STATE__
        } else {
            if(orderListReturn?.data?.length <= 0){
                await OrderListReturn.fetchData(store, params, query)
            }
        }
	}, []);

	const loadHandle = useCallback(() =>{
		dispatch(action_fetch_order_list_return(false));
	}, []);

    return <div>
        <OrderReturnList 
			request={loadHandle}
			orders={orderListReturn?.data} 
			loading={orderListReturn?.loading}
			finished={orderListReturn?.skip!==0 && orderListReturn?.finished}
		/>

		{
			orderListReturn?.skip===0 && orderListReturn?.finished && <OrderListEmpty />
		}
    </div>
}

OrderListReturn.fetchData = async (store, params, search, headers) => {
	await store.dispatch(action_fetch_order_list_return(false, headers));
}

export default OrderListReturn;